export const ProductsSteps = [
    {
        target: '.quick-search ',
        placementBeacon: "bottom",
        disableScrolling: true,
        content: 'You can search the entire Table in this search bar.',
    },
    //new-product-button
    {
        target: '.new-product-button ',
        content: 'Click here to create a New Product.',
    },
   
    //additional-actions-menu
   

    {
        target: '.product-table .MuiDataGrid-actionsCell:nth-child(1) ',
        // disableBeacon: true,
        disableScrolling: true,
        // placement: 'bottom',
        content: 'To edit an item, look for the Edit button in the table.',
    },
    {
        target: '.additional-actions',
        
        content: 'To find additional functions like Exporting the table to Excel and more, click here.',
    },
    // {
    //     target: '.additional-actions-menu',
    //     disableBeacon: true,
    //     placement: 'bottom',
    //     disableScrolling: true,
    //     content: 'You can also show or hide Filters in the table from this menu',
    // },

]